import {language} from "../enum/languages.enum";
import en from "./en";
import rus from "./ru";

export default {
  [language.en]: en,
  [language.ru]: rus
}
